import React from "react";
import { createTheme } from "@mui/material/styles";
import { ThemeProvider } from "@mui/material/styles";
import { useBranding } from "./common/hooks";

/**
 * Theme Handler Hook
 */
export const ThemeSupportProvider = ({ children }) => {
    const theme = createTheme(useBranding().theme);

    return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};
